import { Extension } from '@tiptap/core';
import { createVirtualCursor } from 'prosemirror-virtual-cursor';
import './fakecursor.css';
export function fakeCursor() {
    const rules = [createVirtualCursor()];
    return rules;
}
const FakeTextCursor = Extension.create({
    name: 'fakeCursorPlugin',
    addProseMirrorPlugins() {
        return fakeCursor();
    }
});
export default FakeTextCursor;
